var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "lead-dashboard",
    attrs: {
      "aria-label": "Štatistiky klientov"
    }
  }, [_c('div', {
    staticClass: "dashboard-heading"
  }, [_vm._m(0), _vm.analytics ? _c('span', {
    staticClass: "dashboard-freshness"
  }, [_vm._v(" Aktualizované " + _vm._s(_vm.formattedFreshness) + " ")]) : _vm._e()]), _vm.loading && !_vm.analytics ? _c('div', {
    staticClass: "dashboard-loading"
  }, [_c('span', {
    staticClass: "dashboard-spinner"
  }), _vm._v(" Načítavam štatistiky… ")]) : _vm.error && !_vm.analytics ? _c('div', {
    staticClass: "dashboard-error"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm.analytics ? [_c('div', {
    staticClass: "metric-grid"
  }, _vm._l(_vm.metricCards, function (metric) {
    return _c('article', {
      key: metric.key,
      staticClass: "metric-card",
      "class": "metric-card--".concat(metric.tone)
    }, [_c('div', {
      staticClass: "metric-topline"
    }, [_c('span', [_vm._v(_vm._s(metric.label))]), metric.delta !== null ? _c('span', {
      staticClass: "metric-delta",
      "class": metric.deltaClass
    }, [_vm._v(" " + _vm._s(metric.delta >= 0 ? '↗' : '↘') + " " + _vm._s(_vm.formatSigned(metric.delta)) + "% ")]) : _vm._e()]), _c('strong', [_vm._v(_vm._s(metric.formattedValue))]), _c('small', [_vm._v(_vm._s(metric.note))])]);
  }), 0), _c('div', {
    staticClass: "dashboard-grid dashboard-grid--main"
  }, [_c('article', {
    staticClass: "dashboard-panel funnel-panel"
  }, [_vm._m(1), _c('div', {
    staticClass: "funnel-list"
  }, _vm._l(_vm.analytics.funnel, function (step, index) {
    return _c('div', {
      key: step.key,
      staticClass: "funnel-row"
    }, [_c('div', {
      staticClass: "funnel-copy"
    }, [_c('span', [_vm._v(_vm._s(step.label))]), _c('strong', [_vm._v(_vm._s(step.count))])]), _c('div', {
      staticClass: "funnel-track",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('span', {
      style: {
        width: "".concat(_vm.funnelWidth(step), "%")
      }
    })]), _c('div', {
      staticClass: "funnel-meta"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatPercent(step.conversion)))]), index > 0 ? _c('small', [_vm._v("−" + _vm._s(_vm.funnelDropoff(index)) + " leadov")]) : _vm._e()])]);
  }), 0)]), _c('article', {
    staticClass: "dashboard-panel stage-panel"
  }, [_vm._m(2), _vm.stageRows.length ? _c('div', {
    staticClass: "stage-list"
  }, _vm._l(_vm.stageRows, function (stage) {
    return _c('div', {
      key: stage.key,
      staticClass: "stage-row"
    }, [_c('div', {
      staticClass: "stage-copy"
    }, [_c('strong', [_vm._v(_vm._s(stage.label))]), _c('span', [_vm._v(_vm._s(stage.count) + " " + _vm._s(_vm.clientLabel(stage.count)))])]), _c('div', {
      staticClass: "stage-days"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatDays(stage.average_days)))]), _c('span', [_vm._v("priemer v stave")])]), _c('div', {
      staticClass: "stage-risk",
      "class": {
        'has-risk': stage.stalled_count > 0
      }
    }, [_c('strong', [_vm._v(_vm._s(stage.stalled_count))]), _c('span', [_vm._v("nad " + _vm._s(_vm.analytics.summary.stalled_after_days) + " dní")])])]);
  }), 0) : _c('div', {
    staticClass: "panel-empty"
  }, [_vm._v("Vo vybranom období nie sú aktívne leady.")])])]), _c('div', {
    staticClass: "dashboard-grid dashboard-grid--secondary"
  }, [_c('article', {
    staticClass: "dashboard-panel archive-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._m(3), _c('span', {
    staticClass: "panel-note"
  }, [_vm._v(_vm._s(_vm.analytics.summary.archived) + " spolu")])]), _vm.archiveTotal ? _c('div', {
    staticClass: "archive-groups"
  }, _vm._l(_vm.analytics.archive_groups, function (group) {
    return _c('div', {
      key: group.key,
      staticClass: "archive-group"
    }, [_c('div', {
      staticClass: "archive-copy"
    }, [_c('span', [_vm._v(_vm._s(group.label))]), _c('strong', [_vm._v(_vm._s(group.count))])]), _c('div', {
      staticClass: "archive-track",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('span', {
      style: {
        width: "".concat(_vm.archiveShare(group.count), "%")
      }
    })]), _c('span', {
      staticClass: "archive-share"
    }, [_vm._v(_vm._s(_vm.formatPercent(_vm.archiveShare(group.count))))])]);
  }), 0) : _c('div', {
    staticClass: "panel-empty"
  }, [_vm._v("Žiadne archivované leady vo vybranom období.")]), _vm.otherArchiveDetails.length ? _c('div', {
    staticClass: "archive-details"
  }, [_c('span', {
    staticClass: "archive-details-title"
  }, [_vm._v("Detail iného dôvodu")]), _vm._l(_vm.otherArchiveDetails, function (reason) {
    return _c('span', {
      key: reason.key,
      staticClass: "archive-detail-chip"
    }, [_vm._v(" " + _vm._s(reason.label) + " · " + _vm._s(reason.count) + " ")]);
  })], 2) : _vm._e()]), _c('article', {
    staticClass: "dashboard-panel status-panel"
  }, [_vm._m(4), _c('div', {
    staticClass: "status-grid"
  }, _vm._l(_vm.statusCards, function (status) {
    return _c('div', {
      key: status.key,
      staticClass: "status-card"
    }, [_c('span', [_vm._v(_vm._s(status.label))]), _c('strong', [_vm._v(_vm._s(status.value))])]);
  }), 0), _c('p', {
    staticClass: "dashboard-caveat"
  }, [_vm._v(" Čas v stave sa počíta od poslednej zmeny flow. Historická cesta medzi všetkými stavmi sa zatiaľ neukladá. ")])])])] : _vm._e()], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "dashboard-eyebrow"
  }, [_vm._v("Diagnostika leadov")]), _c('h2', [_vm._v("Čo sa deje s klientmi")]), _c('p', [_vm._v("Všetci klienti vo výbere vrátane organiky a vlastných kontaktov. Výsledky jednotlivých kampaní sú v prehľade Kampane a kontakty.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', [_c('span', {
    staticClass: "panel-kicker"
  }, [_vm._v("Konverzný funnel")]), _c('h3', [_vm._v("Kam sa leady dostali")])]), _c('span', {
    staticClass: "panel-note"
  }, [_vm._v("z vybraného obdobia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', [_c('span', {
    staticClass: "panel-kicker"
  }, [_vm._v("Úzke miesta")]), _c('h3', [_vm._v("Kde sa leady zdržujú")])]), _c('span', {
    staticClass: "panel-note"
  }, [_vm._v("aktuálny stav")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "panel-kicker"
  }, [_vm._v("Straty")]), _c('h3', [_vm._v("Prečo leady končia v archíve")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', [_c('span', {
    staticClass: "panel-kicker"
  }, [_vm._v("Pipeline")]), _c('h3', [_vm._v("Aktuálne rozloženie")])])]);

}]

export { render, staticRenderFns }